import React, { useEffect, useState } from 'react';
import AddModal from './components/common/AddModal';
import Sidebar from './components/common/Sidebar';
import AuthIndex from "./screens/AuthIndex";
import MainIndex from './screens/MainIndex';
import HomePage from './screens/Frontend/Home'; 
import About from './screens/Frontend/About/About'; 
import Admin from './screens/Frontend/Admin/Login'; 
import NotFOund from './screens/Frontend/NotFound'; 
import Shop from './screens/Frontend/Shop/Shop'; 
import Blogs from './screens/Frontend/Blogs/Blogs'; 
import BlogDetails from './screens/Frontend/Blogs/Details'; 
import Contact from './screens/Frontend/Contact/Contact';
import Faqs from './screens/Frontend/Faqs/Faqs';
import HomeDecor from './screens/Frontend/Categories/HomeDecor/SmallCeramics';
import SmallCeramics from './screens/Frontend/Categories/SmallCeramics/SmallCeramics';
import CeramicLamp from './screens/Frontend/Categories/CeramicLamp/CeramicLamp';
import Ceramic from './screens/Frontend/Categories/Ceramic/CeramicLamp';
// import Ceramic from './screens/Frontend/Categories/CeramicLamp/CeramicLamp';
import CeramicVases from './screens/Frontend/Categories/CeramicVases/CeramicVases';
import DriftwoodLamps from './screens/Frontend/Categories/DriftwoodLamps/DriftwoodLamps';
import FloorLamps from './screens/Frontend/Categories/FloorLamps/FloorLamps';
import HavanaLampCollection from './screens/Frontend/Categories/HavanaLampCollection/HavanaLampCollection';
import LampCollection from './screens/Frontend/Categories/LampCollection/HavanaLampCollection';
import NaturalVineLamps from './screens/Frontend/Categories/NaturalVineLamps/NaturalVineLamps';
import NewCeramics from './screens/Frontend/Categories/NewCeramics/NewCeramics';
import Decorative from './screens/Frontend/Categories/Decorative/NewCeramics';
import SculpturalPieces from './screens/Frontend/Categories/SculpturalPieces/NewCeramics';
import NewArrivals from './screens/Frontend/Categories/NewArrivals/NewArrivals';
import RopeLampCollections from './screens/Frontend/Categories/RopeLampCollections/RopeLampCollections';
import RopeLamp from './screens/Frontend/Categories/RopeLamp/RopeLampCollections';
import SalvagedUniqueLamps from './screens/Frontend/Categories/SalvagedUniqueLamps/SalvagedUniqueLamps';
import TeakLamps from './screens/Frontend/Categories/TeakLamps/TeakLamps';
import Teak from './screens/Frontend/Categories/Teak/TeakLamps';
import Lighting from './screens/Frontend/Categories/Lighting/TeakLamps';
import ProductDetails from './screens/Frontend/ProductDetails/ProductDetails';
import Addtocart from './screens/Frontend/Addtocart/Addtocart';
import Checkout from './screens/Frontend/Checkout/Checkout';
import PrivacyPolicy from './screens/Frontend/PrivacyPolicy/PrivacyPolicy';
import RefundReturn from './screens/Frontend/RefundReturn/RefundReturn';
import TnC from './screens/Frontend/TnC/TnC';
import UserDashboard from './screens/Users/UserDashboard';
import WishList from './screens/Frontend/WishList/WishList';
import Octopus from './screens/Frontend/SubCategories/OctopusTheme/OctopusTheme';
import GreenCeramics from './screens/Frontend/SubCategories/GreenCeramics/GreenCeramics';
import EarthToneCeramics from './screens/Frontend/SubCategories/EarthToneCeramics/EarthToneCeramics';
import CreamCeramics from './screens/Frontend/SubCategories/CreamCeramics/CreamCeramics';
import CeramicVasess from './screens/Frontend/SubCategories/CeramicVases/CeramicVases';
import CeramicPlatters from './screens/Frontend/SubCategories/CeramicPlatters/CeramicPlatters';
import CeramicPlates from './screens/Frontend/SubCategories/CeramicPlates/CeramicPlates';
import CeramicBowls from './screens/Frontend/SubCategories/CeramicBowls/CeramicBowls';
import BlueCeramics from './screens/Frontend/SubCategories/BlueCeramics/BlueCeramics';
import WhiteCeramicLamps from './screens/Frontend/SubCategories/WhiteCeramicLamps/WhiteCeramicLamps';
import EarthToneCeramicLamps from './screens/Frontend/SubCategories/EarthToneCeramicLamps/EarthToneCeramicLamps';
import CreamCeramicLamps from './screens/Frontend/SubCategories/CreamCeramicLamps/CreamCeramicLamps';
import CeramicPineappleLamps from './screens/Frontend/SubCategories/CeramicPineappleLamps/CeramicPineappleLamps';
import CeramicCoralLamps from './screens/Frontend/SubCategories/CeramicCoralLamps/CeramicCoralLamps';
import BlueCeramicLamps from './screens/Frontend/SubCategories/BlueCeramicLamps/BlueCeramicLamps';
import NewWoodenLamps from './screens/Frontend/SubCategories/NewWoodenLamps/NewWoodenLamps';
import NewRopeLamps from './screens/Frontend/SubCategories/NewRopeLamps/NewRopeLamps';
import SubNewCeramics from './screens/Frontend/SubCategories/NewCeramics/NewCeramics';
import DriftwoodTableLamps from './screens/Frontend/SubCategories/DriftwoodTableLamps/DriftwoodTableLamps';
import TableLamps from './screens/Frontend/SubCategories/TableLamps/DriftwoodTableLamps';
import DriftwoodFloorLamps from './screens/Frontend/SubCategories/DriftwoodFloorLamps/DriftwoodFloorLamps';
import Driftwood from './screens/Frontend/SubCategories/Driftwood/DriftwoodFloorLamps';
import RopeLamps from './screens/Frontend/SubCategories/RopeLamps/RopeLamps';
import UniqueLamps from './screens/Frontend/SubCategories/UniqueLamps/UniqueLamps';
import SalvagedLamps from './screens/Frontend/SubCategories/SalvagedLamps/SalvagedLamps';
import CapizLamps from './screens/Frontend/Categories/Capiz/Capiz';
import Capiz from './screens/Frontend/Categories/Capizz/Capiz';

function App(props) {
  // Track current path so App re-renders on navigation/back/forward
  const [path, setPath] = useState(window.location.pathname);

  // Hard reload on back/forward restore (bfcache) so scripts & effects re-run
  useEffect(() => {
    const onPageShow = (e) => {
      // Safari/Chrome: restored from bfcache
      if (e.persisted) {
        window.location.reload();
        return;
      }
      // Chrome/Firefox: Navigation Timing shows back_forward
      const entries = performance.getEntriesByType?.('navigation') || [];
      const nav = entries[0];
      if (nav && nav.type === 'back_forward') {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  // Re-render on popstate + when pushState/replaceState are called
  useEffect(() => {
    const onLocationChange = () => setPath(window.location.pathname);

    const wrapHistory = (type) => {
      const orig = window.history[type];
      return function (...args) {
        const ret = orig.apply(this, args);
        window.dispatchEvent(new Event('locationchange'));
        return ret;
      };
    };

    const origPush = window.history.pushState;
    const origReplace = window.history.replaceState;
    window.history.pushState = wrapHistory('pushState');
    window.history.replaceState = wrapHistory('replaceState');

    window.addEventListener('popstate', onLocationChange);
    window.addEventListener('locationchange', onLocationChange);

    return () => {
      window.removeEventListener('popstate', onLocationChange);
      window.removeEventListener('locationchange', onLocationChange);
      window.history.pushState = origPush;
      window.history.replaceState = origReplace;
    };
  }, []);

  const activekey = (pathname) => {
    let res = pathname;
    let baseUrl = process.env.PUBLIC_URL || '';

    baseUrl = baseUrl.split("/");
    res = res.split("/");

    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? "/" + res : "/";

    return res;
  }

  const currentPath = activekey(path);

  // Auth pages check
  if (
    currentPath === '/sign-in' || 
    currentPath === '/sign-up' || 
    currentPath === '/reset-password' || 
    currentPath === '/verification' || 
    currentPath === '/page-404'
  ) {
    return (
      <div id="ebazar-layout" className='theme-blue'>
        <AuthIndex />
      </div>
    );
  }

  if (currentPath === '/') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <HomePage /> 
      </div>
    );
  }
  else if (currentPath === '/about') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <About /> 
      </div>
    );
  }
  else if (currentPath === '/shop') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Shop /> 
      </div>
    );
  }
  else if (currentPath === '/blogs') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Blogs /> 
      </div>
    );
  }
  else if (currentPath === '/404') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NotFOund /> 
      </div>
    );
  }
  else if (currentPath === '/contact') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Contact /> 
      </div>
    );
  }
  else if (currentPath === '/faqs') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Faqs /> 
      </div>
    );
  }
  else if (currentPath === '/small-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <SmallCeramics /> 
      </div>
    );
  }
   else if (currentPath === '/home-decor') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <HomeDecor /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicLamp /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Ceramic /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-vases') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicVases /> 
      </div>
    );
  }
  else if (currentPath === '/driftwood-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <DriftwoodLamps /> 
      </div>
    );
  }
  else if (currentPath === '/floor-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <FloorLamps /> 
      </div>
    );
  }
  else if (currentPath === '/havana-lamp-collection') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <HavanaLampCollection /> 
      </div>
    );
  }
   else if (currentPath === '/lamp-collections') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <LampCollection /> 
      </div>
    );
  }
  else if (currentPath === '/natural-vine') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NaturalVineLamps /> 
      </div>
    );
  }
  else if (currentPath === '/new-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NewCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/decorative-objects') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Decorative /> 
      </div>
    );
  }
   else if (currentPath === '/sculptural-pieces') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <SculpturalPieces /> 
      </div>
    );
  }
  else if (currentPath === '/new-arrivals') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NewArrivals /> 
      </div>
    );
  }
  else if (currentPath === '/rope-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <RopeLampCollections /> 
      </div>
    );
  }
  else if (currentPath === '/rope') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <RopeLamp /> 
      </div>
    );
  }
  else if (currentPath === '/capiz-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CapizLamps/> 
      </div>
    );
  }
  else if (currentPath === '/capiz') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Capiz/> 
      </div>
    );
  }
  else if (currentPath === '/salvaged-unique-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <SalvagedUniqueLamps /> 
      </div>
    );
  }
  else if (currentPath === '/teak-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <TeakLamps /> 
      </div>
    );
  }
  else if (currentPath === '/teak') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Teak /> 
      </div>
    );
  }
   else if (currentPath === '/lighting') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Lighting /> 
      </div>
    );
  }
  else if (currentPath === '/productdetails') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <ProductDetails /> 
      </div>
    );
  }
  else if (currentPath === '/refund-policy') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <RefundReturn /> 
      </div>
    );
  }
  else if (currentPath === '/admin') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Admin /> 
      </div>
    );
  }
  else if (currentPath === '/add-to-cart') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Addtocart /> 
      </div>
    );
  }
  else if (currentPath === '/privacy-policy') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <PrivacyPolicy /> 
      </div>
    );
  }
  else if (currentPath === '/terms-and-conditions') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <TnC /> 
      </div>
    );
  }
  else if (currentPath === '/checkout') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Checkout /> 
      </div>
    );
  }
  else if (currentPath === '/details') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <BlogDetails /> 
      </div>
    );
  }
  else if (currentPath === '/users') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <UserDashboard /> 
      </div>
    );
  }
  else if (currentPath === '/wishlist') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <WishList /> 
      </div>
    );
  }
  else if (currentPath === '/octopus-theme') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Octopus /> 
      </div>
    );
  }
  else if (currentPath === '/green-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <GreenCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/earth-tone-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <EarthToneCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/cream-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CreamCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-vasess') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicVasess /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-platters') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicPlatters /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-plates') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicPlates /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-bowls') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicBowls /> 
      </div>
    );
  }
  else if (currentPath === '/blue-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <BlueCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/white-ceramic-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <WhiteCeramicLamps /> 
      </div>
    );
  }
  else if (currentPath === '/earth-tone-ceramic-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <EarthToneCeramicLamps /> 
      </div>
    );
  }
  else if (currentPath === '/cream-ceramic-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CreamCeramicLamps /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-pineapple-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicPineappleLamps /> 
      </div>
    );
  }
  else if (currentPath === '/ceramic-coral-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <CeramicCoralLamps /> 
      </div>
    );
  }
  else if (currentPath === '/blue-ceramic-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <BlueCeramicLamps /> 
      </div>
    );
  }
  else if (currentPath === '/new-wooden-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NewWoodenLamps /> 
      </div>
    );
  }
  else if (currentPath === '/new-rope-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <NewRopeLamps /> 
      </div>
    );
  }
  else if (currentPath === '/sub-new-ceramics') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <SubNewCeramics /> 
      </div>
    );
  }
  else if (currentPath === '/driftwood-table-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <DriftwoodTableLamps /> 
      </div>
    );
  }
  else if (currentPath === '/table-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <TableLamps /> 
      </div>
    );
  }
  else if (currentPath === '/driftwood-floor-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <DriftwoodFloorLamps /> 
      </div>
    );
  }
  else if (currentPath === '/driftwood') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <Driftwood /> 
      </div>
    );
  }
  else if (currentPath === '/rope-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <RopeLamps /> 
      </div>
    );
  }
  else if (currentPath === '/unique-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <UniqueLamps /> 
      </div>
    );
  }
  else if (currentPath === '/salvaged-lamps') {
    return (
      <div id="main-container-home" className='theme-blue'>
        <SalvagedLamps /> 
      </div>
    );
  }

  // Default layout
  return (
    <div id="ebazar-layout" className='theme-blue'>
      <Sidebar activekey={currentPath} history={props.history} />
      <AddModal />
      <MainIndex activekey={currentPath} />
    </div>
  );
}

export default App;
